import vocModel from '../../models/voc/voc.model';
import ViewBase from '../view-base.view';

export default function VocHistoryView() {
    ViewBase.call(this);

    let listOfVocHistoryItems = [];

    let selectedVocId = '';

    let _loadVocHistoryItems = () => {
        this.showLoading();

        vocModel.getVocHistoryItems(            
            (result) => {
                this.hideLoading();
                
                listOfVocHistoryItems = result != null ? result : [];
            },
            (error) => {
                listOfVocHistoryItems = [];

                this.hideLoading();
                this.handleError(error);
            },
            selectedVocId
        );
    }

    let _downloadAttachments = (vocHistoryId) => {
        this.showLoading();

        vocModel.downloadHistoryFileAttachments(            
            (result) => {
                this.hideLoading();
            },
            (error) => {
                this.hideLoading();
                this.handleError(error);
            },
            vocHistoryId
        );
    }

    return {
        oninit: (vnode) => {
            if (vnode.attrs.vocId) {
                selectedVocId = vnode.attrs.vocId;

                _loadVocHistoryItems();
            }
        },
        view: (vnode) => {
            return [
                m('.row',
                    m('.col-md-12',
                        m('.card',
                            m('.card-body',
                                m(".table-responsive",
                                    m("table.table table-striped",
                                        [
                                            m("thead",
                                                m("tr.align-middle",
                                                    [
                                                        m("th", { "scope": "col" }, this.getText("LT00000480", "Log Date/Time")),
                                                        m("th", { "scope": "col" }, this.getText("LT00000305", "Update User")),
                                                        m("th", { "scope": "col" }, this.getText("LT00000471", "Person-In-Charge")),
                                                        m("th", { "scope": "col" }, this.getText("LT00000473", "Revised Due Date")),
                                                        m("th", { "scope": "col" }, this.getText("LT00000481", "Updated Status")),
                                                        m("th", { "scope": "col" }, this.getText("LT00000482", "Updated Reason")),
                                                        m("th", { "scope": "col" }, this.getText("LT00000152", "Remarks")),
                                                        m("th", { "scope": "col" }, this.getText("LT00000483", "Files Count")),
                                                    ])
                                            ),
                                            m("tbody",
                                                listOfVocHistoryItems.length == 0 &&
                                                m("tr", { "class": "align-middle" },
                                                    m("td", { "colspan": "8" }, this.getText("EM00000141", "No records found."))
                                                ),
                                                listOfVocHistoryItems.map(item =>
                                                    [
                                                        m("tr",
                                                            [
                                                                m("td", item.updateDate),
                                                                m("td", item.updateUserName),
                                                                m("td", item.picName),
                                                                m("td", item.dueDate),
                                                                m("td", item.statusName),
                                                                m("td", item.reason),
                                                                m("td", { style: "word-wrap: break-word; white-space: normal !important;" }, item.remark),
                                                                m("td", m("a", { "href": "javascript:;", onclick: () => { _downloadAttachments(item.vocHistoryId); } }, m("span", item.attachmentNumber))),
                                                            ])
                                                    ]),
                                            )
                                        ]
                                    )
                                ),
                            )
                        )
                    ),
                ),
                this.getBaseViews()
            ]
        }
    }
}
